import { render, staticRenderFns } from "./btn-checkout.vue?vue&type=template&id=1782cab1"
import script from "./btn-checkout.vue?vue&type=script&lang=js"
export * from "./btn-checkout.vue?vue&type=script&lang=js"
import style0 from "./btn-checkout.vue?vue&type=style&index=0&id=1782cab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports